<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<div (click)="onClick()"
     class="slds-notification-container"
     id="notifications"
     style="z-index: 9999">

  <section *ngFor="let note of notes"
           [attr.aria-describedby]="note.bodyId"
           [attr.aria-labelledby]="note.noteId"
           class="slds-notification"
           role="dialog">
    <div [id]="note.bodyId"
         class="slds-notification__body">
      <a class="slds-notification__target slds-media">
        <span class="slds-icon_container slds-media__figure"
              title="event">
          <svg [class.slds-icon-text-error]="note.isError" [class.slds-icon-text-light]="note.isInfo"
               [class.slds-icon-text-success]="note.isSuccess"
               [class.slds-icon-text-warning]="note.isWarning"
               aria-hidden="true"
               class="slds-icon slds-icon_small">
            <use [attr.xlink:href]="note.useHref"/>
          </svg>
        </span>
        <div class="slds-media__body">
          <h2 [id]="note.noteId"
              class="slds-text-heading_small slds-m-bottom_xx-small">
            <span class="slds-assistive-text">event notification:</span>{{note.subject}}</h2>
          <div *ngFor="let line of this.note.multiLine">{{line}}</div>
        </div>
      </a>
      <button (click)="onClickNote(note, $event)"
              class="slds-button slds-button_icon slds-button_icon-container slds-notification__close"
              title="Dismiss">
        <svg aria-hidden="true" class="slds-button__icon">
          <use href="/assets/icons/utility-sprite/svg/symbols.svg#close"/>
        </svg>
        <span class="slds-assistive-text">Dismiss</span>
      </button>
    </div>
  </section>

</div>
